<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-copyright element-without-heading" id="copyright">
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content"><b>Selected Stories: Science Fiction, Volume 1</b></p>
<p class="alignment-block-content alignment-block-content-center copyright-content"><b>by Kevin J. Anderson</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Copyright © 2018 WordFire, Inc.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Complete list of previous publication information at end of this book.</p>
</div>
</div>
<p class="first first-in-chapter first-full-width copyright-content">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.</p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">ISBN: 978-1-61475-653-8</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Cover design by Janet McDonald</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson, Art Director</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Published by</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press, an imprint of</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">PO Box 1840</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Monument CO 80132</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson &amp; Rebecca Moesta, Publishers</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press Trade Paperback Edition 2018</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Printed in the USA</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Join our WordFire Press Readers Group and get free books, sneak previews, updates on new projects, and other giveaways.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Sign up for free at wordfirepress.com</p>
</div>
</div>
<p class="created-with-vellum"><a href="http://tryvellum.com/created" target="_blank"><span class="created-with-vellum-image-decorator"><span class="created-with-vellum-image-size-container"><img alt="Created with Vellum" class="created-with-vellum-image" src="images/vellum-created.png"/></span></span> <span class="created-with-vellum-text">Created with Vellum</span></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?105139d2